/* import __COLOCATED_TEMPLATE__ from './table-control.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { deleteTable } from 'prosemirror-tables';
import { findTable, selectTable } from 'prosemirror-utils';
import { tracked } from '@glimmer/tracking';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { NodeSelection } from 'prosemirror-state';
import { deleteSelection } from 'prosemirror-commands';
let ToolsTableEditorTableControl = (_class = class ToolsTableEditorTableControl extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "hoveredAction", _descriptor, this);
    _defineProperty(this, "DELETE_BUTTON_OFFSET", 35);
  }
  get controlStyle() {
    let rect = this.args.controlPoint.clientRect;
    return sanitizeHtml(`
      left: ${rect.x}px;
      top: ${rect.y}px;
      width: ${rect.width}px;
      height: ${rect.height}px;
      `);
  }
  get deleteButtonStyle() {
    let rect = this.args.controlPoint.clientRect;
    return sanitizeHtml(`
      left: ${rect.width + this.DELETE_BUTTON_OFFSET}px;
      `);
  }
  get isSelected() {
    let state = this.args.composer.state.prosemirrorState;
    if (state.selection.$anchor.nodeAfter?.attrs.type === 'table') {
      return true;
    }
    return false;
  }
  setHoveredAction(actionName) {
    this.hoveredAction = actionName;
  }
  selectTableNode() {
    if (this.isSelected) {
      return;
    }
    let table = findTable(this.args.composer.state.prosemirrorState.selection);
    if (!table) {
      return;
    }
    let tr = this.args.composer.state.prosemirrorState.tr;
    tr.setSelection(NodeSelection.create(tr.doc, table.pos));
    this.args.composer.commands.dispatch(tr);
  }
  selectTable() {
    let tr = this.args.composer.state.prosemirrorState.tr;
    this.args.composer.commands.dispatch(selectTable(tr));
    this.args.composer.commands.focus();
  }
  deleteTable() {
    deleteTable(this.args.composer.state.prosemirrorState, this.args.composer.commands.dispatch);
  }
  deleteSelectedTable() {
    deleteSelection(this.args.composer.state.prosemirrorState, this.args.composer.commands.dispatch);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "hoveredAction", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, "setHoveredAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setHoveredAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectTableNode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectTableNode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectTable", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectTable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteTable", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteTable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteSelectedTable", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteSelectedTable"), _class.prototype), _class);
export { ToolsTableEditorTableControl as default };